export default __webpack_public_path__ + "static/media/factor_item_4.f5077ea0.png";